export default from './comment-header';



// WEBPACK FOOTER //
// ./app/components/comment-header/index.js